enum Actions {
  SET_TIMEFRAME_KIND = 'setTimeframeKind',
  SET_TIMEFRAME = 'setTimeframe',
  SET_SHIFTPLAN = 'setShiftplan',
  SET_PRINT_VIEW_KIND = 'setPrintViewKind',
}

export default Actions;
